<style lang="css">
</style>

<template lang="html">

<el-card>

    <table-template ref="table-template" actionUrl="carShow/order/findCarShowOrders.action" :queryParams="queryParams">
      <template slot="search">

        <el-select v-model="queryParams.payStatus" clearable @change="$refs['table-template'].search()" placeholder="支付状态">
          <el-option label="待支付" :value="1"></el-option>
          <el-option label="支付成功" :value="2"></el-option>
          <el-option label="支付失败" :value="3" ></el-option>
          <el-option label="支付关闭" :value="4"></el-option>
          <el-option label="转为退款" :value="5"></el-option>
        </el-select>

        <el-select v-model="queryParams.state" clearable @change="$refs['table-template'].search()" placeholder="兑换状态">
          <el-option label="申请兑换" :value="1"></el-option>
          <el-option label="已兑换" :value="2"></el-option>
          <el-option label="申请退款" :value="3"></el-option>
          <el-option label="退款完成" :value="4"></el-option>
        </el-select>

        <el-date-picker
          v-model="queryParams.rangeTime"
          type="datetimerange"
          range-separator="至"
          @change="onDateTimeRangeChange"
          start-placeholder="支付开始日期"
          end-placeholder="支付结束日期">
        </el-date-picker>

        <el-date-picker
          v-model="queryParams.createTimes"
          type="datetimerange"
          range-separator="至"
          @change="onDateTimeRangeChange2"
          start-placeholder="创建开始日期"
          end-placeholder="创建结束日期">
        </el-date-picker>

        <el-input v-model="queryParams.keyword" style="width:250px;" placeholder="下订单人信息 / 渠道名"></el-input>

        <el-button @click="$refs['table-template'].search()" type="primary">搜索</el-button>
        <el-button type="warning" style="margin-right:20px;" @click="excelExport()">导出</el-button>
      </template>

      <template slot="item">
        <el-table-column label="下订人" width="250">
          <template scope="scope">
            {{scope.row.personName}} - {{scope.row.personPhone}}
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="意向车系" width="180">
        </el-table-column>
        <el-table-column prop="channelName" label="渠道来源">
        </el-table-column>
        <el-table-column label="支付状态">
          <template scope="scope">
            {{scope.row.payStatus | payStatusFilter}}
          </template>
        </el-table-column>
        <el-table-column label="支付时间" width="200">
          <template scope="scope">
            {{scope.row.payTime | dateTimeFormat}}
          </template>

        </el-table-column>
        <el-table-column label="创建时间" width="200">
          <template scope="scope">
            {{scope.row.createTime | dateTimeFormat}}
          </template>

        </el-table-column>
        <el-table-column label="退款状态">
          <template scope="scope">
            {{scope.row.refundStatus | refundStatusFilter}}
          </template>
        </el-table-column>
        <el-table-column label="兑换情况" width="150">
            <template scope="scope">
                {{scope.row.exchangeState | exchangeStateFilter}}
                <a v-if="scope.row.exchangeImage" @click="showInvoice(scope.row)">[购车发票]</a>
            </template>
        </el-table-column>
        <el-table-column label="处理时间" width="200">
          <template scope="scope">
            {{scope.row.auditingEmployee}} {{scope.row.auditingTime | dateTimeFormat}}
          </template>

        </el-table-column>
        <el-table-column label="操作" width="150">
            <template scope="scope">
                <el-button type="text"
                    v-if="scope.row.payStatus==2 && scope.row.exchangeState!=2"
                    v-confirm-input
                    confirm-input-placeholder="请输入退款备注"
                    :confirm-input-data="scope.row"
                    @onInputConfirm="refund">退款</el-button>
                <el-button type="text"
                  v-if="scope.row.exchangeState==1"
                  @click="exchange(scope.row)">兑换处理</el-button>

                <div v-if="scope.row.remark">
                    {{scope.row.remark}}
                </div>
            </template>
        </el-table-column>
      </template>
    </table-template>

    <el-dialog
      title="查看购车发票"
      :visible.sync="dialogVisible"
      width="30%">

      <el-row>
        <el-col style="padding:10px;color:#999;" :span="16">您的称呼</el-col>
        <el-col style="padding:10px;" :span="8"><b>{{selectOrderInfo.exchangePersonName}}</b></el-col>
      </el-row>

      <el-row>
        <el-col style="padding:10px;color:#999;" :span="16">联系方式</el-col>
        <el-col style="padding:10px;" :span="8"><b>{{selectOrderInfo.exchangePersonPhone}}</b></el-col>
      </el-row>

      <el-row>
        <el-col style="padding:10px;color:#999;" :span="16">收货地址</el-col>
        <el-col style="padding:10px;" :span="8"><b>{{selectOrderInfo.exchangeAddress}}</b></el-col>
      </el-row>

      <el-row>
        <el-col style="padding:10px;color:#999;" :span="16">购车发票</el-col>
        <el-col :span="8">
          <img v-img :src="selectOrderInfo.exchangeImage" style="width:120px;height:120px;"></img>
          <div style="width:120px;text-align:center;color:#eee;padding:10px;">点击查看大图</div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">朕 已 阅</el-button>
      </span>
    </el-dialog>
</el-card>

</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import CarExhibitionModel from '@/framework/models/CarExhibitionModel'
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'car-exhibition-order-manager',
  extends: BasicPager,
  components: {
    TableTemplate
  },
  data: function () {
    return {
      imageUrl: Config.imageUrl,
      selectOrderInfo: {},
      dialogVisible: false,
      queryParams: {
        carShowId: null
      }
    }
  },
  filters: {
    exchangeStateFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '申请兑换'
          break
        case 2:
          str = '已兑换'
          break
        case 3:
          str = '申请退款'
          break
        case 4:
          str = '退款完成'
          break
        case 5:
          str = '未兑换'
          break
        default:
          str = '无'
      }
      return str
    },
    payStatusFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '待支付'
          break
        case 2:
          str = '支付成功'
          break
        case 3:
          str = '支付失败'
          break
        case 4:
          str = '支付关闭'
          break
        case 5:
          str = '转入退款'
          break
        default:
          str = '无'
      }
      return str
    },
    refundStatusFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '退款成功'
          break
        case 2:
          str = '退款关闭'
          break
        case 3:
          str = '退款处理中'
          break
        case 4:
          str = '退款异常'
          break
        case 5:
          str = '未申请'
          break
        case 6:
          str = '超时订单'
          break
        default:
          str = '无'
      }
      return str
    }
  },

  created: function () {
    let carShowInfoId = this.$route.params.carShowInfoId
    this.queryParams.carShowId = carShowInfoId
  },
  activated: function () {
    let carShowInfoId = this.$route.params.carShowInfoId
    this.queryParams.carShowId = carShowInfoId
    this.$refs['table-template'].loadList()
  },
  methods: {
    excelExport: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let url = Config.baseUrl + '/carShow/order/exportOrders.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath +
          '&carShowId=' + this.queryParams.carShowId

      if (this.queryParams.rangeTime && this.queryParams.rangeTime[0]) {
        url += '&startTime=' + this.queryParams.rangeTime[0].getTime() + '&endTime=' + this.queryParams.rangeTime[1].getTime()
      }
      if (this.queryParams.createTimes && this.queryParams.createTimes[0]) {
        url += '&createStartTime=' + this.queryParams.createTimes[0].getTime() + '&createEndTime=' + this.queryParams.createTimes[1].getTime()
      }

      if (this.queryParams.payStatus) {
        url += '&payStatus=' + this.queryParams.payStatus
      }
      if (this.queryParams.state) {
        url += '&state=' + this.queryParams.state
      }

      if (this.queryParams.keyword) {
        url += '&keyword=' + this.queryParams.keyword
      }

      window.open(url)
    },
    onDateTimeRangeChange2: function (dateTimeRange) {
      if (!dateTimeRange) {
        this.queryParams.createStartTime = null
        this.queryParams.createEndTime = null
        this.$refs['table-template'].search()
        return
      }
      if (dateTimeRange[0] && dateTimeRange[1]) {
        this.queryParams.createStartTime = dateTimeRange[0].getTime()
        this.queryParams.createEndTime = dateTimeRange[1].getTime()
      }
      this.$refs['table-template'].search()
    },
    onDateTimeRangeChange: function (dateTimeRange) {
      if (!dateTimeRange) {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
        this.$refs['table-template'].search()
        return
      }
      if (dateTimeRange[0] && dateTimeRange[1]) {
        this.queryParams.startTime = dateTimeRange[0].getTime()
        this.queryParams.endTime = dateTimeRange[1].getTime()
      }

      this.$refs['table-template'].search()
    },
    showInvoice: function (data) {
      this.selectOrderInfo = data
      this.dialogVisible = true
    },
    refund: function (inputText, data) {
      let _this = this
      let params = {
        orderId: data.id,
        note: inputText,
        employee: this.loginInfo.realName
      }

      let listener = {
        success: function (dataInfo) {
          _this.$message.success('删除成功!')
          _this.$refs['table-template'].search()
        }
      }
      CarExhibitionModel.refundOrder(_this, params, listener)
    },
    exchange: function (data) {
      const h = this.$createElement
      const input1 = h('input', { attrs: { class: 'el-input__inner', placeholder: '请输入快递单号（必填）' } })
      const input2 = h('input', { style: 'margin-top:10px', attrs: { class: 'el-input__inner', placeholder: '请输入备注（可不输入）' } })
      let _this = this
      this.$msgbox({
        title: '兑换处理',
        message: h('div', null, [
          input1,
          input2
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            let input1Value = input1.elm.value

            if (!input1Value) {
              _this.$message({
                message: '快递单号不能为空！',
                type: 'warning'
              })
              return
            }
            let input2Value = input2.elm.value
            let note = '[快递单号：' + input1Value + ']' + (input2Value ? ' 备注：' + input2Value : '')

            let params = {
              orderId: data.id,
              note: note,
              courierNumber: input1Value,
              employee: _this.loginInfo.realName
            }

            let listener = {
              success: function (dataInfo) {
                _this.$message.success('删除成功!')
                _this.$refs['table-template'].search()
                done()
              },
              error: function () {
                done()
              }
            }
            CarExhibitionModel.exchangeOrder(_this, params, listener)
          } else {
            input1.elm.value = ''
            input2.elm.value = ''
            done()
          }
        }
      }).catch(action => {
        input1.elm.value = ''
        input2.elm.value = ''
      })
    }
  }
}

</script>
